
'use client';

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionCard } from "@/components/section-card";
import { HelpCircle, ChevronDown } from "lucide-react";

const faqData = [
  {
    question: "What exactly does the AI Website Audit analyze?",
    answer: "Our AI audit performs a comprehensive analysis covering Core Web Vitals (FCP, LCP, CLS), Time to Interactive (TTI), Speed Index, analytics and tracking setup (like Google Analytics & Tag Manager), on-page SEO factors, technical issues (broken links, crawl errors, mobile-friendliness), and website accessibility (WCAG standards)."
  },
  {
    question: "How long does the website analysis take?",
    answer: "The AI-powered analysis is quite fast. You'll typically receive your initial audit results and optimization suggestions within a few minutes after submitting your URL."
  },
  {
    question: "Is the website analyzer tool free?",
    answer: "Yes, our basic website analyzer tool provides a free initial audit. For more in-depth analysis and to fix the identified issues, we offer various service packages."
  },
  {
    question: "What kind of report will I receive?",
    answer: "You'll receive a detailed report that includes an overall audit summary of your website's performance, analytics, and tracking events. It also provides a prioritized list of actionable optimization suggestions."
  },
  {
    question: "How can these audit findings help my business?",
    answer: "By identifying performance bottlenecks, SEO weaknesses, tracking inaccuracies, and accessibility issues, our audit helps you improve user experience, increase search engine visibility, make data-driven decisions, and ensure your site is usable by everyone. Ultimately, this can lead to higher engagement, better conversion rates, and business growth."
  },
  {
    question: "Do you offer services to fix the identified issues?",
    answer: "Absolutely! Based on the audit findings, we suggest suitable service packages ('Basic Tune-Up', 'Advanced Audit & Fix', 'Enterprise Solution') designed to address the identified issues. We also offer custom packages for unique needs."
  },
  {
    question: "What are Core Web Vitals, and why are they important?",
    answer: "Core Web Vitals are a set of specific factors that Google considers important in a webpage's overall user experience. They include Largest Contentful Paint (LCP), First Input Delay (FID, though INP is now replacing it), and Cumulative Layout Shift (CLS). Improving these metrics can lead to better search engine rankings and a more satisfying experience for your visitors."
  },
  {
    question: "Can you help with Google Analytics and Tag Manager setup?",
    answer: "Yes, our audit includes a review of your current analytics and tracking setup. Our service packages can also cover the implementation or correction of Google Analytics, Tag Manager, and custom tracking events to ensure accurate data collection."
  },
  {
    question: "What if I need a custom solution not listed in the packages?",
    answer: "We understand that every website is unique. If your needs go beyond our standard packages, we offer a 'Custom Package' option. You can contact us to discuss your specific requirements, and we'll tailor a solution for you."
  }
];

export function FaqSection() {
  return (
    <section className="py-12 sm:py-16 w-full">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <SectionCard
          title="Frequently Asked Questions"
          icon={<HelpCircle className="h-8 w-8" />}
          description="Find answers to common questions about our AI web audit and optimization services."
          className="bg-card shadow-xl"
        >
          <Accordion type="single" collapsible className="w-full">
            {faqData.map((faq, index) => (
              <AccordionItem value={`item-${index}`} key={index}>
                <AccordionTrigger className="text-left hover:no-underline">
                  <span className="font-medium text-base">{faq.question}</span>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </SectionCard>
      </div>
    </section>
  );
}
